import React, { Component } from 'react';
import JobAdvertLayout from './JobAdvertLayout';

class DistilleryJobAdvertSeniorEngineer extends Component {
  render() {
    return (
      <div>
        <JobAdvertLayout
          jobtitle="Senior Engineer"
          description={
            <div>
              We are looking for a talented Senior Engineer to join our growing
              development team in Edinburgh.
            </div>
          }
          headingsectionone={
            <div>
              What we need
            </div>
          }
          sectionone={
            <div>
              <p>
                To achieve arc-net’s goal of delivering these services to our customers we
                need a passionate DevOps engineer with a proven ability to deploy and
                maintain quality architecture as part of an agile, multi-disciplinary team.
                You should be confident taking charge of projects and work with our developers
                to be able to rapidly reach MVP deployments to test out new features and concepts.
                You should help to bring clarity to the company’s vision for its products and
                create a standard as an example to the team. As a member of the engineering team
                at arc-net you will have the opportunity to work with some leading-edge technology
                including Blockchain, microservice architecture supported by docker and running
                in a variety of cloud environments. As part of a fast-moving start-up, you will
                have the opportunity to bring in your own ideas and experience and guide the
                company on the best practice for them.
              </p>
              <p>
                DevOps is a way of life here and engineers who embody the DevOps philosophy
                will find the culture a familiar one. In time, as we onboard new customers,
                we expect to grow the team under you so there will likely be opportunities
                to develop into leadership roles as they become available.
              </p>
            </div>
          }
          headingsectiontwo={
            <div>
              About you
            </div>
          }
          sectiontwo={
            <div>
              <ul>
                <li>You should be a tenacious problem solver.</li>
                <li>
                  You love working within a strong team and communicate well to the team’s output.
                </li>
                <li>
                  You must have expert level Java experience with a strong degree in
                  Computer Science and at least 4 years of experience to back it up.
                </li>
                <li>
                  You should be comfortable working with the Spring framework, specifically
                  SpringBoot.
                </li>
                <li>
                  You should have a variety of experience working with typical engineering
                  pipeline tools including version control, code-quality and testing tools.
                </li>
                <li>
                  You should have some experience working with public cloud infrastructure,
                  ideally AWS.
                </li>
              </ul>
            </div>
          }
          headingsectionthree={
            <div>
              Ideally you would also have
            </div>
          }
          sectionthree={
            <div>
              <ul>
                <li>Experience with NodeJS and/or other modern script frameworks and languages.</li>
                <li>Good understanding of REST and how to implement and consume an API.</li>
                <li> Experience working with containers, ideally Docker.</li>
                <li>Experience with Microservices.</li>
                <li>Good knowledge of command line git.</li>
                <li>Experience with Agile development methodologies.</li>
                <li>
                  Experience with CI pipeline tools such as Travis and automated
                  release processes.
                </li>
              </ul>
            </div>
          }
          headingsectionfour={
            <div>
              What you can expect from us
            </div>
          }
          sectionfour={
            <div>
              <ul>
                <li>Competitive salary and benefits.</li>
                <li>Stock options for qualifying candidates.</li>
                <li>Great Edinburgh location.</li>
                <li>Dynamic start-up culture.</li>
                <li>Flexible working environment (including remote working where required).</li>
                <li>
                  An open and welcoming culture with a great appetite for new technology
                  and ideas.
                </li>
              </ul>
            </div>
          }
        />
      </div >
    );
  }
}

export default DistilleryJobAdvertSeniorEngineer;



// WEBPACK FOOTER //
// ./src/components/common/JobAdvertSeniorEngineer.js